import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';
import {Navigate} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const Map = lazy(() => import('@/pages/mngt/map/Map'));
const BaseMapList = lazy(() => import('@/pages/mngt/map/BaseMapList'));
const BaseMapOrdr = lazy(() => import('@/pages/mngt/map/BaseMapOrdr'));

const mapRoutes: RouteObject[] = [
  {
    path: '/mngt/map',
    element: withSuspense(<Map />),
    children: [
      {
        index: true,
        element: <Navigate to="basemap" replace />
      },
      {
        path: 'basemap',
        element: withSuspense(<BaseMapList />)
      },
      {
        path: 'ordr',
        element: withSuspense(<BaseMapOrdr />)
      }
    ]
  }
];

export default mapRoutes;
